<div class="relative">
  <!-- Trigger button -->
  <button
    type="button"
    (click)="toggle(); $event.stopPropagation()"
    class="announce-btn relative flex items-center justify-center w-10 h-10 rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 shadow-sm transition"
    [class.has-unread]="hasUnread"
    [attr.aria-expanded]="isOpen"
    [attr.aria-label]="unreadLabel"
    pTooltip="Announcements"
    tooltipPosition="top"
  >
    <svg
      class="w-5 h-5 text-gray-600 dark:text-gray-300"
      [class.animate]="hasUnread"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <g class="megaphone">
        <path
          d="M4 10v4a1 1 0 0 0 .76.97L14 17.5a.5.5 0 0 0 .62-.48V6.98a.5.5 0 0 0-.62-.48L4.76 9.03A1 1 0 0 0 4 10Z"
        />
        <path d="M7.4 15.55V18a1.6 1.6 0 0 0 3.2 0v-1.65" />
      </g>
      <g class="text-amber-500 dark:text-amber-400">
        <path class="wave wave-1" d="M17.4 9.6a4 4 0 0 1 0 4.8" />
        <path class="wave wave-2" d="M19.9 7.4a7.5 7.5 0 0 1 0 9.2" />
      </g>
    </svg>
    @if (hasUnread) {
      <span class="announce-ping" aria-hidden="true">
        <span class="announce-ping-ring"></span>
        <span class="announce-ping-dot"></span>
      </span>
    }
  </button>

  @if (isOpen) {
    <!-- Backdrop -->
    <div
      class="announcement-backdrop fixed inset-0 z-[999999] flex items-center justify-center px-4"
      (click)="close()"
    >
      <!-- Animated frame -->
      <div
        class="announcement-frame relative"
        (click)="$event.stopPropagation()"
      >
        <!-- Dialog -->
        <div
          class="announcement-panel relative flex flex-col max-h-[85vh] overflow-hidden rounded-2xl"
        >
          <!-- Animated top gradient line -->
          <div class="announcement-gradient-line"></div>

          <!-- Header -->
          <div
            class="announcement-header flex items-center gap-3 px-5 py-4 shrink-0"
          >
            <div class="announcement-icon">
              <i class="pi pi-megaphone"></i>
            </div>

            <h3 class="announcement-title min-w-0">
              Release Version : {{ announcements[0]?.release_version || "—" }}
            </h3>

            <!-- Download -->
            @if (announcements[0]?.attachment_url) {
              <button
                type="button"
                (click)="downloadAttachment(announcements[0])"
                [pTooltip]="'Download ' + announcements[0].attachment_name"
                tooltipPosition="top"
                class="announcement-download ml-auto"
                aria-label="Download attachment"
              >
                <i class="pi pi-download"></i>
              </button>
            }

            <!-- Close -->
            <button
              type="button"
              (click)="close()"
              class="announcement-close"
              [class.ml-auto]="!announcements[0]?.attachment_url"
              aria-label="Close"
            >
              <i class="pi pi-times text-sm"></i>
            </button>
          </div>

          <!-- List -->
          <ul class="announcement-list flex-1">
            @for (a of announcements; track a.id) {
              <li
                class="announcement-item"
                [class.announcement-item-unread]="!a.is_read"
              >
                <markdown
                  class="md-preview text-sm"
                  [data]="a.release_note || '_No release note available._'"
                ></markdown>
              </li>
            } @empty {
              <li class="announcement-empty">
                <div class="announcement-empty-icon">
                  <i class="pi pi-megaphone"></i>
                </div>

                <p class="announcement-empty-title">No announcements yet</p>

                <p class="announcement-empty-text">
                  Updates from your team will appear here.
                </p>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
</div>
